// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.detailPlanWrapperItem .price:first-of-type{
    margin-right: 6px;
}
.PlanComparisonWrapperItem .planComparisonPrice:first-of-type{
    margin-right: 6px;
}
.divSelect .MuiSelect-select {
    font-size: 14px !important;
}
.divSelect .MuiMenuItem-root{
    font-size: 14px !important;
}

#mui-5 .MuiMenuItem-root{
    font-size: 14px !important;
}
/*.wrapperPlanComparison {*/
/*    width: max-content !important;*/
/* }*/
`, "",{"version":3,"sources":["webpack://./src/salesCore/plan/assets/style.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;AACA,2BAA2B;AAC3B,qCAAqC;AACrC,KAAK","sourcesContent":[".detailPlanWrapperItem .price:first-of-type{\r\n    margin-right: 6px;\r\n}\r\n.PlanComparisonWrapperItem .planComparisonPrice:first-of-type{\r\n    margin-right: 6px;\r\n}\r\n.divSelect .MuiSelect-select {\r\n    font-size: 14px !important;\r\n}\r\n.divSelect .MuiMenuItem-root{\r\n    font-size: 14px !important;\r\n}\r\n\r\n#mui-5 .MuiMenuItem-root{\r\n    font-size: 14px !important;\r\n}\r\n/*.wrapperPlanComparison {*/\r\n/*    width: max-content !important;*/\r\n/* }*/\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
